import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.large-image-slider' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--large-image-slider' )[0], {
          type: 'loop',
          pagination: false,
          arrows: true,
          perPage: 1,
          perMove: 1,
          gap: '32px',
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'large-image-slider', COMPONENT );
} )( app );
